// 地図タイルの URL と出典。画面の Leaflet (OverviewMiniMap/SiteMap) と PDF のラスタライザ (pdf/render-map.ts)
// が同じ定義を使う。ズーム上限は各タイルセットのネイティブ最大 (それ以上は拡大表示)。
export const TILES = {
  /** 淡色地図 — 章のサブマップの既定ベース。 */
  pale: 'https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png',
  /** 標準地図 — 入力地図 (SiteMap) と地盤章。 */
  std: 'https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png',
  /** 色別標高図 (起伏) — z5〜15 のみ。 */
  relief: 'https://cyberjapandata.gsi.go.jp/xyz/relief/{z}/{x}/{y}.png',
  /** 全国最新写真 (シームレス)。 */
  photo: 'https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg',
} as const;

// 水害ハザードの公式ラスタータイル (浸水深で配色済み, z2〜17)。バックエンドは判定用に中心タイル
// 1 枚しか取得しないため、広域の面はこのラスターをブラウザ/PDF 側で重ねて描く。
export const WATER_RASTER_URL: Record<string, string> = {
  XKT026: 'https://disaportaldata.gsi.go.jp/raster/01_flood_l2_shinsuishin_data/{z}/{x}/{y}.png',
  XKT027: 'https://disaportaldata.gsi.go.jp/raster/03_hightide_l2_shinsuishin_data/{z}/{x}/{y}.png',
  XKT028: 'https://disaportaldata.gsi.go.jp/raster/04_tsunami_newlegend_data/{z}/{x}/{y}.png',
};

/** タイルセットのネイティブ最大ズーム。URL テンプレートから引く。 */
export function tileMaxNativeZoom(url: string): number {
  if (url === TILES.relief) return 15;
  if (url.startsWith('https://disaportaldata.gsi.go.jp/')) return 17;
  return 18;
}

/** 航空写真か (PDF では写真だけ z+1 のタイルで描いて解像感を上げる)。 */
export function isPhotoTiles(url: string): boolean {
  return url === TILES.photo;
}

export const GSI_ATTRIBUTION_HTML =
  '<a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank" rel="noreferrer">国土地理院</a>';

// PDF の地図直下に出す出典 (地理院タイル利用規約: 出典の明記)。
export const ATTRIBUTION_TEXT = {
  gsi: '地図: 地理院タイル（国土地理院）',
  hazard: '浸水想定: ハザードマップポータルサイト（国土交通省）',
} as const;
